import React, { useEffect } from "react";
import "./Session_Type.css";
import Common_Title_2 from "../../common/common_components/common_title_2/Common_Title_2";
import { useNavigate } from "react-router-dom";
import { AllSpandan_Session_Type } from '../../../features/admin/spandan/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from "../../../utils/IDS";
import { encodeId } from "../../../utils/common";
const Session_Type = () => {

  const dispatch = useDispatch();

  const all_spandan_session_type = useSelector((state) => state.spandan.all_spandan_session_type);

  useEffect(() => {
    dispatch(AllSpandan_Session_Type());
  }, [dispatch]);



  const navigate = useNavigate()

  return (
    <section className="Session_Type">
      <div className="container">
        <div className="content_holder">
          <Common_Title_2 subText="Spandan Sessions Type" />

          <div className="type_holder">
            <div className="row justify-content-center">
              {all_spandan_session_type?.map((item) => {
                return (
                  <div className="col-lg-3 col-md-4 col-sm-5 col-10 mb-4">
                    <div className="type_card" onClick={() => { navigate(`/panic-healing/${encodeId(item.id)}`) }}>
                      <div className="img_holder">
                        <img src={`${IDS.IMG_URL}${item?.Spandan_Session_Type?.image}`} className="type_img" />
                      </div>
                      <div className="overlay"></div>
                      <p className="type_text">{item?.name}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Session_Type;
